// Community Management APIs

/**
 * @function ApiClient#GetCommunityInfo
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetCommunityInfo(cid, options = {}) {
  return await this._get(`/community/${cid}/info`, options);
}

/**
 * @function ApiClient#GetCommunityCountData
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetCommunityCountData(cid, options = {}) {
  return await this._get(`/community/${cid}/info_count`, options);
}

// Package Management APIs

/**
 * @function ApiClient#GeneratePackageID
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GeneratePackageID(cid, options = {}) {
  return await this._get(`/community/${cid}/generate_package_id`, options);
}

/**
 * @function ApiClient#ReleasePackageID
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} options = {}
 */
export async function ReleasePackageID(cid, pid, options = {}) {
  return await this._delete(`/community/${cid}/release_package_id?id=${pid}`, options);
}

/**
 * @function ApiClient#ValidatePackageIDs
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} packages
 * @param {any} options = {}
 */
export async function ValidatePackageIDs(cid, packages, options = {}) {
  return await this._post(`/community/${cid}/validate_package_ids`, { Packages: packages }, options);
}

/**
 * @function ApiClient#SavePackage
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function SavePackage(cid, data, options = {}) {
  return await this._post(`/community/${cid}/package`, data, options);
}

/**
 * @function ApiClient#DeletePackage
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} options = {}
 */
export async function DeletePackage(cid, pid, options = {}) {
  return await this._delete(`/community/${cid}/package/${pid}`, options);
}

/**
 * @function ApiClient#UpdatePackageToWaitReturn
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} options = {}
 */
export async function UpdatePackageToWaitReturn(cid, pid, options = {}) {
  return await this._put(`/community/${cid}/package_to_wait_return/${pid}`, null, options);
}

/**
 * @function ApiClient#UpdatePackageToReturn
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} options = {}
 */
export async function UpdatePackageToReturn(cid, pid, options = {}) {
  return await this._put(`/community/${cid}/package_to_return/${pid}`, null, options);
}

/**
 * @function ApiClient#GetPackageListHistory
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetPackageListHistory(cid, options = {}) {
  return await this._get(`/community/${cid}/package_list?s=2`, options);
}
